import { userInfoSync } from 'hub-http/userInfo';
import Raven from 'raven-js';
import enviro from 'enviro';
export const isUngated = gateName => {
  try {
    var _userInfo$gates;
    const userInfo = userInfoSync();
    return !!(userInfo !== null && userInfo !== void 0 && (_userInfo$gates = userInfo.gates) !== null && _userInfo$gates !== void 0 && _userInfo$gates.includes(gateName));
  } catch (err) {
    if (enviro.isQa()) {
      console.error(err);
    }
    Raven.captureException(err, {
      extra: {
        message: 'Error getting user info from `userInfoSync`'
      }
    });
  }
  return false;
};